// extracted by mini-css-extract-plugin
module.exports = {"addTipPage":"AddTipPage_addTipPage__kWeow","addTipBlock":"AddTipPage_addTipBlock__3Re1-"};